import React from 'react';
import TituloDaPagina from '../../components/TituloDaPagina'
export default function Sobre() {
  return (
    <>
      <TituloDaPagina>Sobre</TituloDaPagina>
    </>
  );
}
